import React from 'react';

const EmbeddedVideoComponent = ({ section }) => {
  const videoUrl = `https://www.youtube.com/embed/${section.videoId}?autoplay=${section.autoplay}`;
  const videoContainer = {
    display: 'flex',
    'justify-content': 'center',
    margin: '4rem 0',
  };
  return (
    <div key={section.index} style={videoContainer}>
      <iframe title="yt" width="1112" height="626" src={videoUrl} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" />
    </div>
  );
};

export default EmbeddedVideoComponent;




// WEBPACK FOOTER //
// ./src/Components/EmbeddedVideoComponent.js